import { render, staticRenderFns } from "./ListaImagens.vue?vue&type=template&id=5f1edc70&scoped=true"
import script from "./ListaImagens.vue?vue&type=script&lang=js"
export * from "./ListaImagens.vue?vue&type=script&lang=js"
import style0 from "./ListaImagens.vue?vue&type=style&index=0&id=5f1edc70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1edc70",
  null
  
)

export default component.exports